module.exports = __webpack_public_path__ + "static/img/book7.572923f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book7.jpg
// module id = Fus4
// module chunks = 1